import Image from "next/image";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  showText?: boolean;
  showBeta?: boolean;
  className?: string;
}

const sizes = {
  sm: { icon: 24, text: "text-lg" },
  md: { icon: 32, text: "text-xl" },
  lg: { icon: 40, text: "text-2xl" },
};

export function Logo({ size = "md", showText = true, showBeta = false, className = "" }: LogoProps) {
  const { icon, text } = sizes[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Image
        src="/velyq_icon.png"
        alt="Velyq"
        width={icon}
        height={icon}
        className="object-contain"
      />
      {showText && (
        <div className="flex items-center gap-1.5">
          <span className={`font-bold ${text}`}>Velyq</span>
          {showBeta && (
            <span className="rounded-full border border-primary/30 bg-primary/10 px-1.5 py-0.5 text-[10px] font-medium text-primary">
              Beta
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export function LogoIcon({ size = 32, className = "" }: { size?: number; className?: string }) {
  return (
    <Image
      src="/velyq_icon.png"
      alt="Velyq"
      width={size}
      height={size}
      className={`object-contain ${className}`}
    />
  );
}
